(function () {
  var bar = document.querySelector('.atc-bar-v2');
  var form = document.querySelector('.product__form');
  if (!bar || !form) return;
  var priceEl = bar.querySelector('[data-atc-price]');
  var instEl = bar.querySelector('[data-atc-installment]');
  var btn = bar.querySelector('[data-atc-trigger]');
  var qtyInput = form.querySelector('input[name="quantity"]');
  var currency = bar.getAttribute('data-currency') || 'USD';
  var locale = bar.getAttribute('data-locale') || undefined;

  /**
   * Parse a market-formatted money string (€69,89 / $1,234.56 / 69,89 €).
   */
  var parseMoney = function (str) {
    var cleaned = String(str).replace(/[^\d.,-]/g, '');
    if (!cleaned) return NaN;
    var lastComma = cleaned.lastIndexOf(',');
    var lastDot = cleaned.lastIndexOf('.');
    if (lastComma > lastDot) {
      // European: 1.234,56 or 69,89
      cleaned = cleaned.replace(/\./g, '').replace(',', '.');
    } else {
      // US / ISO: 1,234.56 or 69.89
      cleaned = cleaned.replace(/,/g, '');
    }
    return parseFloat(cleaned);
  };

  /**
   * Format amount using the same decimal/currency style as the buy-box sample,
   * falling back to Intl with the active cart currency.
   */
  var formatMoney = function (amount, sample) {
    sample = String(sample || '').trim();
    var lastComma = sample.lastIndexOf(',');
    var lastDot = sample.lastIndexOf('.');
    var useCommaDecimal = sample !== '' && lastComma > lastDot;
    var fixed = Number(amount).toFixed(2);
    if (useCommaDecimal) fixed = fixed.replace('.', ',');

    var prefixMatch = sample.match(/^([^\d\-]+)/);
    var suffixMatch = sample.match(/([^\d]+)$/);
    var prefix = prefixMatch ? prefixMatch[1] : '';
    var suffix = suffixMatch ? suffixMatch[1] : '';
    // Only treat as currency affix if it has a non-separator character
    if (prefix && /[^\s.,]/.test(prefix)) return prefix + fixed;
    if (suffix && /[^\s.,]/.test(suffix)) return fixed + suffix;

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (e) {
      return currency + ' ' + Number(amount).toFixed(2);
    }
  };

  var getVisiblePrice = function () {
    var checked = form.querySelector('.option-input:checked');
    var label = checked ? form.querySelector('label[for="' + checked.id + '"]') : null;
    if (!label) return null;
    var sel = form.classList.contains('buy-box--sub')
      ? '.buy-box__price--sub strong'
      : '.buy-box__price--onetime strong';
    var el = label.querySelector(sel) || label.querySelector('.buy-box__price--onetime strong');
    return el ? el.textContent.trim() : null;
  };

  var sync = function () {
    var p = getVisiblePrice();
    if (!p) return;
    var amount = parseMoney(p);
    if (isNaN(amount)) return;
    var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1;
    var total = amount * qty;
    // qty 1: reuse buy-box string so trailing-zeros / market format stay identical
    var totalStr = qty === 1 ? p : formatMoney(total, p);
    if (priceEl) priceEl.textContent = '- ' + totalStr;
    if (instEl) instEl.textContent = formatMoney(total / 4, p);
  };

  document.addEventListener('change', function (e) {
    if (form.contains(e.target)) requestAnimationFrame(sync);
  });
  document.addEventListener('click', function (e) {
    if (form.contains(e.target)) requestAnimationFrame(sync);
  });
  document.addEventListener('input', function (e) {
    if (form.contains(e.target)) requestAnimationFrame(sync);
  });
  sync();
  setTimeout(sync, 600);

  if (btn) {
    btn.addEventListener('click', function () {
      var submit = form.querySelector('.product__add-to-cart');
      if (submit) submit.click();
    });
  }

  var observer = new IntersectionObserver(function (entries) {
    var entry = entries[0];
    if (entry.boundingClientRect.bottom < 0) {
      bar.classList.add('shown');
      bar.removeAttribute('inert');
    } else {
      bar.classList.remove('shown');
      bar.setAttribute('inert', '');
    }
  });
  observer.observe(form);
})();
